import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, hero, images, mainProduct } from '../data/content';
export function MainProduct() {
  return <section className="bg-cream text-ink" data-id="element-142" data-mp="3ci9i1udyki7n">
      <div className="mx-auto grid max-w-content items-center gap-10 px-5 py-16 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:py-24" data-id="element-143" data-mp="38i91o47atwxy">
        <img src={images.main} alt={images.mainAlt} loading="lazy" className="mx-auto aspect-[4/5] w-full max-w-md rounded-3xl object-cover object-[55%_50%] shadow-[0_24px_50px_-20px_rgba(104,69,54,0.5)] lg:max-w-none" data-id="element-144" data-mp="33kz584lhsl0m" />

        <div className="text-center lg:text-left" data-id="element-145" data-mp="3qus5t3gnfx">
          <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-gold-deep" data-id="element-146" data-mp="3r8h40k36cjd3">
            El producto principal
          </p>
          <h2 className="mt-3 font-display text-[2rem] font-semibold uppercase leading-[1.05] tracking-[0.04em] text-brown sm:text-5xl" data-id="element-147" data-mp="3mc9uyifherqx">
            Desafío <span className="font-script text-[2.6rem] normal-case tracking-normal text-rose sm:text-6xl" data-id="element-148" data-mp="2auqwf3cujcyp">Mujer de</span>{' '}
            Proverbios 31
          </h2>
          <p className="mt-4 font-sans text-[1rem] leading-relaxed text-ink sm:text-lg" data-id="element-149" data-mp="3e2pax58v0zte">
            {mainProduct.subtitle}
          </p>

          <p className="mt-7 font-sans text-sm font-semibold text-ink-soft" data-id="element-150" data-mp="301v0kh294os3">{mainProduct.intro}</p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-151" data-mp="350y6e3q22z14">
            {mainProduct.areas.map(area => <li key={area} className="whitespace-nowrap rounded-full border border-gold/40 bg-white px-3.5 py-1.5 font-sans text-[0.82rem] font-medium text-brown" data-id="element-152" data-mp="2qcbj9fu6t2zc">
                {area}
              </li>)}
          </ul>

          <div className="mx-auto mt-9 max-w-md lg:mx-0" data-id="element-153" data-mp="2habzifrsfksp">
            <CtaButton href={checkoutUrl} data-id="element-154" data-mp="2mckv7jw1p0yi">{hero.cta}</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}